if (!customElements.get('ers-sushi-collection')) {
  customElements.define('ers-sushi-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.ers-sc__track');
      if (!this.track) return;
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.more = this.querySelector('[data-more]');
      this.status = this.querySelector('[role="status"]');
      this.page = 1;
      this.querySelector('[data-controls]').hidden = false;
      this.more.hidden = Number(this.dataset.total) <= 8;
      this.selector = this.querySelector('select');
      if (this.selector) {
        this.querySelector('[data-selector]').hidden = false;
        this.selector.addEventListener('change', () => this.load(true));
      }
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.more?.addEventListener('click', () => this.load());
      this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: 'instant' });
        }
      });
      this.addEventListener('error', event => {
        if (event.target.tagName !== 'IMG') return;
        event.target.hidden = true;
        event.target.parentElement.querySelector('.ers-sc__no-image').hidden = false;
      }, true);
      this.querySelectorAll('img').forEach(image => {
        if (image.complete && !image.naturalWidth) {
          image.hidden = true;
          image.parentElement.querySelector('.ers-sc__no-image').hidden = false;
        }
      });
      this.resize = new ResizeObserver(() => this.updateControls());
      this.resize.observe(this.track);
      this.announce();
      this.updateControls();
    }
    disconnectedCallback() { this.resize?.disconnect(); this.controller?.abort(); }
    move(direction) {
      const card = this.track.firstElementChild;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updateControls() {
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    announce() {
      this.status.textContent = this.dataset.status.replace('[shown]', this.track.children.length).replace('[total]', this.dataset.total);
    }
    async load(replace = false) {
      if (this.busy) return;
      this.busy = true;
      this.more.disabled = true;
      if (this.selector) this.selector.disabled = true;
      this.track.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 15000);
      try {
        const choice = replace ? this.selector.selectedOptions[0] : null;
        const expectedHandle = choice ? choice.value : this.dataset.collection;
        const requestedPage = replace ? 1 : this.page + 1;
        const url = new URL(choice ? choice.dataset.url : this.dataset.url, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid collection URL');
        url.searchParams.set('view', 'ers-sushi-assortment');
        url.searchParams.set('page', String(requestedPage));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const batch = doc.querySelector('[data-ers-assortment]');
        if (!batch || batch.dataset.ersAssortment !== expectedHandle || Number(batch.dataset.page) !== requestedPage) throw new Error('Invalid collection response');
        const ids = new Set(replace ? [] : [...this.track.children].map(card => card.dataset.productId));
        const cards = [...batch.querySelectorAll('.ers-sc__card')].filter(card => !ids.has(card.dataset.productId));
        const first = cards[0];
        if (replace) {
          this.track.replaceChildren(...cards);
          this.dataset.url = choice.dataset.url;
          this.dataset.collection = choice.value;
          this.querySelector('h3').textContent = choice.textContent;
          this.track.setAttribute('aria-label', choice.textContent);
          this.querySelector('.ers-sc__all').href = choice.dataset.url;
          this.track.scrollLeft = 0;
        } else this.track.append(...cards);
        this.page = requestedPage;
        this.dataset.total = batch.dataset.total;
        this.announce();
        this.more.hidden = Number(batch.dataset.total) <= 8;
        this.more.textContent = this.more.dataset.label;
        if (this.page >= Number(batch.dataset.pages) || cards.length === 0) {
          this.more.disabled = true;
          this.more.textContent = this.dataset.complete;
        } else this.more.disabled = false;
        if (first && !replace) {
          first.querySelector('a').focus({ preventScroll: true });
          this.track.scrollTo({ left: first.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'instant' });
        }
        this.updateControls();
      } catch (error) {
        this.status.textContent = this.dataset.error;
        this.more.disabled = false;
        if (this.selector) this.selector.value = this.dataset.collection;
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        if (this.selector) {
          this.selector.disabled = false;
          if (replace) this.selector.focus({ preventScroll: true });
        }
        this.track.removeAttribute('aria-busy');
      }
    }
  });
}
